import { render, staticRenderFns } from "./CTColSettings.vue?vue&type=template&id=991a9394&scoped=true"
import script from "./CTColSettings.vue?vue&type=script&lang=js"
export * from "./CTColSettings.vue?vue&type=script&lang=js"
import style0 from "./CTColSettings.vue?vue&type=style&index=0&id=991a9394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991a9394",
  null
  
)

export default component.exports